import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AccountService } from '../../_services/account.service';

@Component({
  selector: 'app-header-admin',
  templateUrl: './header-admin.component.html',
  styleUrls: ['./header-admin.component.css']
})
export class HeaderAdminComponent implements OnInit {
  collapsed = true;
  
  constructor(
    private accountService: AccountService,
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  logout(){
    this.accountService.logout();
    this.router.navigate(['home']);
  }

}
